import cn from 'classnames'
import genericSs from '../../../assets/styles/generic.module.scss'
import { getTaskStatusClass } from '../getTaskStatusClass'
import styles from './TaskStatusPill.module.scss'

/** Colored status pill — shared by table-row selects, the detail panel select,
 *  and the structured-task read-only display. `className` lets a host bump the
 *  size for its context (e.g. the detail panel's 14px scale). */
const TaskStatusPill = ({ value, className }: { value: string; className?: string }) => (
  <span
    className={cn(
      genericSs.reportingStatus,
      getTaskStatusClass(value),
      styles.statusPill,
      className,
    )}
  >
    {value}
  </span>
)

export default TaskStatusPill
